import { Component, OnInit } from '@angular/core';
import { ActivatedRoute} from '@angular/router'


@Component({
    selector: 'app-admin-main',
    templateUrl: './admin-main.component.html',
    styleUrls: ['./admin-main.component.scss']
})
export class AdminMainComponent implements OnInit {
    test : Date = new Date();
    noLocation: boolean;
    
    constructor(
        private route: ActivatedRoute) { }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            console.log(params);

            if (params['reason'] === 'no-location') {
                this.noLocation = true;
            }else{
                this.noLocation = false;
            }

        });
    }


      
}
